var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agreement" }, [
    _c("div", {
      staticClass: "text",
      domProps: { textContent: _vm._s(_vm.getSplitText("{privacy_policy}", 0)) }
    }),
    _vm._v(" "),
    _c("a", {
      attrs: { href: "#" },
      domProps: { textContent: _vm._s(_vm.privacyPolicy) },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.clicked($event)
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "text",
      domProps: { textContent: _vm._s(_vm.getSplitText("{privacy_policy}", 1)) }
    }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "garena-logo",
        attrs: {
          src:
            "https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/garena_logo.png"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05f3c99e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f3c99e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GSAgreement.vue
// module id = null
// module chunks = 